import { Box, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import backbluebtn from "../../../../Utils/Images/backbluebtn.png";
import { GetSingleChallenge } from "../../../../APIs/Function/Workout/Challenges/GetSingleChallenge";

const SingleChallenge = () => {
  const [singleChallenge, setSingleChallenge] = useState({});
  const [loading, setLoading] = useState(false);

  const { id } = useParams();

  const handleSingleChallenge = async () => {
    try {
      setLoading(true);
      let res = await GetSingleChallenge(id);
      setSingleChallenge(res.r);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleSingleChallenge();
  }, []);
  console.log(singleChallenge);
  return (
    <>
      {" "}
      {loading ? (
        <Box sx={{ mt: "25%" }}>
          <CircularProgress></CircularProgress>
        </Box>
      ) : (
        <Box>
          <Box
            sx={{
              bgcolor: "#31AEF4",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: { xs: "50px", md: "70px", lg: "70px" },
              p: "10px",
              boxSizing: "border-box",
            }}
          >
            <Link to={"/weeklychallanges"}>
              <Box
                sx={{
                  height: { xs: "50px", md: "60px", lg: "60px" },
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img height={"100%"} src={backbluebtn} alt="back" />
              </Box>
            </Link>
            <Box>
              <Typography
                sx={{
                  fontFamily: "Open Sans",
                  fontSize: { md: "30px", sm: "20px" },
                  fontWeight: 600,
                  lineHeight: "36px",
                  color: "#FFFFFF",
                }}
              >
                Challenge Details
              </Typography>
            </Box>
            <Box></Box>
          </Box>
          <Box sx={{ display: "flex", height: "80vh" }}>
            {/* image box */}

            <Box
              sx={{
                display: "flex",

                m: "auto",
                boxSizing: "border-box",
                justifyContent: "cneter",
                alignItems: "center",
                width: "50%",
                flexWrap: "wrap",
              }}
            >
              <Box sx={{ m: "auto", width: "200px", height: "200px" }}>
                <img
                  width={"100%"}
                  height={"100%"}
                  src={`https://api-qhealth.equitysofttechnologies.com/upload/images/${singleChallenge.image}`}
                  alt=""
                />
              </Box>
            </Box>
            {/* details box */}
            <Box
              sx={{
                width: "50%",
                border: "1px solid #E8E8E8",
                p: 2,
                boxSizing: "border-box",
                textAlign: "left",
              }}
            >
              <Box sx={{ p: 2, boxSizing: "border-box", mt: 2 }}>
                <Typography>Title : {singleChallenge.title}</Typography>
              </Box>
              <Box sx={{ p: 2, boxSizing: "border-box", mt: 2 }}>
                <Typography>
                  Challenge Type: {singleChallenge.c_type}
                </Typography>
              </Box>
              <Box sx={{ p: 2, boxSizing: "border-box", mt: 2 }}>
                <Typography>
                  Reward Title : {singleChallenge.r_title}
                </Typography>
              </Box>
              <Box sx={{ p: 2, boxSizing: "border-box", mt: 2 }}>
                <Typography>
                  Description : {singleChallenge.description}
                </Typography>
              </Box>

              <Box sx={{ p: 2, boxSizing: "border-box", mt: 2 }}>
                <Typography>Parameter: {singleChallenge.parameter}</Typography>
              </Box>
              <Box sx={{ p: 2, boxSizing: "border-box", mt: 2 }}>
                <Typography>
                  Parameter Type : {singleChallenge.parameter_type}
                </Typography>
              </Box>
            </Box>
          </Box>{" "}
        </Box>
      )}
    </>
  );
};

export default SingleChallenge;
